<template>
  <v-app class="layout">
    <Navigation />
    <v-main style="background-color: rgb(var(--v-theme-background))">
      <v-container class="page-wrapper">
        <router-view />
      </v-container>
    </v-main>
    <Footer />
    <Help />
    <IntercomChatBot />
    <MessageHost />
    <ConfirmHost />
  </v-app>
</template>

<script>
import Navigation from "./components/Layout/Navigation.vue";
import Footer from "./components/Layout/Footer.vue";
import Help from "./components/help/Help.vue";
import IntercomChatBot from "./components/IntercomChatbot.vue";
import MessageHost from "./components/Layout/MessageHost.vue";
import ConfirmHost from "./components/Layout/ConfirmHost.vue";

export default {
  name: "Layout",
  components: {
    Navigation,
    Footer,
    Help,
    IntercomChatBot,
    MessageHost,
    ConfirmHost,
  },
};
</script>

<style lang="scss">
.page-wrapper {
  padding: 20px 20px 20px 20px;
  min-height: 100%;
}

.layout {
  height: 100%;
}

.container {
  max-width: unset !important;
}
</style>
